import React from 'react';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    content: "This tool helped me optimize my video tags and increased my views by 50%! The category-specific suggestions are spot on.",
    author: "Alex K.",
    role: "Gaming Creator",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  },
  {
    content: "As an educational content creator, finding the right tags was always a challenge. This generator makes it so much easier!",
    author: "Sarah M.",
    role: "Educational YouTuber",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  },
  {
    content: "The trending tag suggestions help me stay current and reach new audiences. My channel growth has been amazing!",
    author: "Mike R.",
    role: "Tech Reviewer",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  }
];

export default function YouTubeTestimonials() {
  return (
    <section className="py-20 bg-red-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          What Content Creators Are Saying
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105">
              <Quote className="w-8 h-8 text-red-500 mb-4" />
              <p className="text-gray-600 mb-4">{testimonial.content}</p>
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full mr-4 object-cover ring-2 ring-red-200"
                />
                <div>
                  <span className="font-semibold text-gray-900 block">{testimonial.author}</span>
                  <span className="text-red-600 text-sm">{testimonial.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}